import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renderiza os cards de estatísticas da aba de Frequência.
 * Usa um layout flex responsivo.
 */
const AttendanceStatsCards = ({ 
    periodStats, 
    weeklyAverageStr, 
    consecutiveAbsences, 
    isHighRisk, 
    riskLevel 
}) => {
    return (
        <div className="d-flex flex-wrap gap-3 mb-4">
            {/* Presenças no período */}
            <div className="bg-success-subtle rounded-0 p-3 d-flex align-items-center flex-grow-1" style={{ minWidth: '180px' }}>
                <i className="mdi mdi-check-circle-outline text-success font-size-24 me-3"></i>
                <div>
                    <p className="text-success mb-0 font-size-12 fw-medium">Presenças no período</p>
                    <h5 className="mb-0 fw-bold text-success">{periodStats.attended}</h5>
                </div>
            </div>

            {/* Faltas no período */}
            <div className="bg-danger-subtle rounded-0 p-3 d-flex align-items-center flex-grow-1" style={{ minWidth: '180px' }}>
                <i className="mdi mdi-close-circle-outline text-danger font-size-24 me-3"></i>
                <div>
                    <p className="text-danger mb-0 font-size-12 fw-medium">Faltas no período</p>
                    <h5 className="mb-0 fw-bold text-danger">{periodStats.absent}</h5>
                </div>
            </div>

            {/* Média Semanal (geral) */}
            <div className="bg-light rounded-0 p-3 d-flex align-items-center flex-grow-1" style={{ minWidth: '180px' }}>
                <i className="mdi mdi-chart-bar text-muted font-size-24 me-3"></i>
                <div>
                    <p className="text-muted mb-0 font-size-12 fw-medium">Média semanal</p>
                    <h5 className="mb-0 fw-bold text-dark">{weeklyAverageStr}</h5>
                </div>
            </div>

            {/* Ausências Consecutivas */}
            <div className="bg-light rounded-0 p-3 d-flex align-items-center flex-grow-1" style={{ minWidth: '180px' }}>
                <i className="mdi mdi-account-alert-outline text-muted font-size-24 me-3"></i>
                <div>
                    <p className="text-muted mb-0 font-size-12 fw-medium">Ausências consecutivas</p>
                    <h5 className="mb-0 fw-bold text-dark">{consecutiveAbsences}</h5>
                </div>
            </div>

            {/* Risco de Abandono */}
            <div className={`rounded-0 p-3 d-flex align-items-center flex-grow-1 ${isHighRisk ? 'bg-danger-subtle' : 'bg-light'}`} style={{ minWidth: '180px' }}>
                <i className={`mdi mdi-account-remove-outline font-size-24 me-3 ${isHighRisk ? 'text-danger' : 'text-muted'}`}></i>
                <div>
                    <p className={`mb-0 font-size-12 fw-medium ${isHighRisk ? 'text-danger' : 'text-muted'}`}>Risco de abandono</p>
                    <h5 className={`mb-0 fw-bold ${isHighRisk ? 'text-danger' : 'text-dark'}`}>{riskLevel}</h5>
                </div>
            </div>
        </div>
    );
};

AttendanceStatsCards.propTypes = {
    periodStats: PropTypes.shape({
        attended: PropTypes.number,
        absent: PropTypes.number
    }).isRequired,
    weeklyAverageStr: PropTypes.string.isRequired,
    consecutiveAbsences: PropTypes.number.isRequired,
    isHighRisk: PropTypes.bool.isRequired,
    riskLevel: PropTypes.string.isRequired
};

export default AttendanceStatsCards;
